/*
  Description :It is the routing file where all the routes are handled.
*/
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PositionedSnackbar from "./components/UI/alert";
import { usePopUpContext } from "./Context/PopupMessage";
import LoginLayout from "./layout/LoginLayout";
import DashboardLayout from "./layout/DashboardLayout";
import Login from "./components/pages/login";
import MainPage from "./components/pages/MainPage";
import InvoiceDetails from "./components/pages/InvoiceDetails";

const getBaseURL = () => {
  const baseUrl = window.location.pathname.split('/eserv/')[0] || '';
  return baseUrl + '/eserv';
};

const App = (props) => {
  const { loading, popupMessage } = usePopUpContext();
  const baseURL = getBaseURL();
  return (
    <>
      {/* <div className="WebPage"> */}
      {/* basename={baseURL}*/}
      <Router  basename={baseURL} >
        <Routes>
          <Route element={<LoginLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Login />} />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route path="/Dashboard" element={<MainPage />} />
         
          </Route>
          <Route element={<DashboardLayout />}>
            <Route path="/InvoiceDetails" element={<InvoiceDetails />} />
          </Route>
        </Routes>
      </Router>
      {loading ? (
        <Backdrop
          sx={{ color: "orange", opacity: 0.5, zIndex: (theme) => 999999 }}
          open={loading} // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}
      {popupMessage.state ? <PositionedSnackbar /> : null}
      {/* </div> */}
    </>
  );
};

export default App;
